import { render, staticRenderFns } from "./AggiungiBici.vue?vue&type=template&id=1ab42392"
import script from "./AggiungiBici.vue?vue&type=script&lang=js"
export * from "./AggiungiBici.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports